import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { I18N, ILocaleInfos } from '../../Store/I18n/Types';
import { IApplicationState } from '../../Store';
import '../../App.css';

import { History } from 'history';
import { RouteComponentProps } from 'react-router-dom';
import { IDashboardState, IFiltersDetail } from '../../Store/Dashboard/Types';
import { getDashboardDetail } from '../../Store/Dashboard/Actions';

import { ISearchState } from '../../Store/Search/Types';
import { IUserState } from '../../Store/User/Types';
import { ElectionType, ICircoFilters, IDataHmsPercent, IDataLegisCirco, IElectionDetailFilters, IElectionFilters, IElectionsState, PersonFunction } from '../../Store/Elections/Types';
import _ from 'lodash';
import { getDashboardCirconscription, getDashboardElectionDetail, getTimeAllocationLegislative, getXlsDashboardElection, getXlsDashboardElectionDetail, getXlsDashboardLegislativ, saveCircoFilters, setElectionTable } from '../../Store/Elections/Actions';
import { Export } from '../Dashboard/Export';
import { BiWindowClose } from "react-icons/bi";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { ElectionTableDashboard } from './ElectionTableDashboard';
import { ElectionTableDetails } from './ElectionTableDetails';
import { isNullOrUndefined } from '../../Utils/Various';

interface IPropsFromState {
  i18n: I18N;
  localeInfos: ILocaleInfos;
  router: RouteComponentProps<{}>;
  dashboard: IDashboardState;
  search: ISearchState;
  user: IUserState;
  elections: IElectionsState;
}

interface IPropsFromDispatch {
  getDashboardDetail: typeof getDashboardDetail
  setElectionTable: typeof setElectionTable
  getDashboardCirconscription: typeof getDashboardCirconscription
  getXlsDashboardElectionDetail: typeof getXlsDashboardElectionDetail
  getXlsDashboardElection: typeof getXlsDashboardElection
  getXlsDashboardLegislativ: typeof getXlsDashboardLegislativ
  saveCircoFilters: typeof saveCircoFilters
  getDashboardElectionDetail: typeof getDashboardElectionDetail
  getTimeAllocationLegislative: typeof getTimeAllocationLegislative
}

interface IState {
  activeTab: ElectionType;
  showTableDetails: boolean;
  selectedCell: any;
  selectedIndex: number;
  constituency_id: number[];
  constituency_str: string[];
  loaded_data: boolean;
  loaded_virt_data: boolean;
  isAllCirconscriptionsSelected: boolean;
  constituency_virt_id: number[];
  constituency_virt_str: string[];
  isAllCirconscriptionsVirtSelected: boolean;
  open: boolean;
  circMenuAnchor: HTMLElement | null;
  circMenuOpen: boolean;
  circVirtMenuAnchor: HTMLElement | null;
  circVirtMenuOpen: boolean;
  regional_data: any;
}

interface IOwnProps {
  history: History;
}

type AllProps =
  MD.WithTheme &
  MD.WithStyles &
  IPropsFromState &
  IPropsFromDispatch &
  IOwnProps;

const styles = (theme: any) => MD.createStyles({
  menus: {
    display: 'flex',
    flexFlow: 'column',
    flexWrap: 'wrap',
  },
  menuPopper: {
    position: "absolute",
    top: "130px",
    left: "40px",
    transform: " translate3d(444px, 41px, 0px)",
    willChange: "transform",
    zIndex: 1203,
    height: 600,
    overflow: 'auto'
  },
  closeWindow: {
    position: 'absolute',
    right: '20px',
    marginTop: '-20px',
    '&:hover': {
      color: 'red',
    }
  },
  searchButton: {
    float: "right",
    margin: 5,
    width: "50%",
    cursor: 'pointer',
  },
})

export class ElectionsLegisContentComponent extends React.Component<AllProps, IState> {
  itemRefs: any
  public constructor(props: AllProps) {
    super(props);
    this.itemRefs = React.createRef();
    this.state = {
      activeTab: (props.elections.study_type_id === 30 || props.elections.study_type_id === 32) ? ElectionType.CIRCONSCRIPTION : ElectionType.NATIONAL,
      showTableDetails: false,
      selectedCell: null,
      selectedIndex: -1,
      constituency_id: [],
      constituency_str: [],
      loaded_data: false,
      loaded_virt_data: false,
      isAllCirconscriptionsSelected: true,
      constituency_virt_id: [],
      constituency_virt_str: [],
      isAllCirconscriptionsVirtSelected: false,
      open: false,
      circMenuAnchor: null,
      circMenuOpen: false,
      circVirtMenuAnchor: null,
      circVirtMenuOpen: false,
      regional_data: null,
    }
    this.itemRefs = [];
  }

  static getDerivedStateFromProps(props: AllProps, state: IState) {

    if (props.elections.circonscriptions.length > 0 && state.loaded_data === false) {
      state.constituency_id = props.elections.allCirconscriptionsId
      state.constituency_str = props.elections.allCirconscriptionsStr
      state.loaded_data = true
    }
    if (props.elections.circonscriptionsVirt.length > 0 && state.loaded_virt_data === false) {
      //state.constituency_virt_id = props.elections.allCirconscriptionsVirtId
      //state.constituency_virt_str = props.elections.allCirconscriptionsVirtStr
      //state.loaded_virt_data = false
    }
    if (props.elections.regional_data.length > 0 && state.regional_data === null) {
      state.regional_data = props.elections.regional_data
    }
    if (props.elections.tableType === ElectionType.CIRCONSCRIPTION) {
      state.activeTab = ElectionType.CIRCONSCRIPTION
    }
    return state
  }


  public componentDidUpdate(prevProps: AllProps, prevState: IState) {
    if (!_.isEqual(prevProps.elections.study_type_id, this.props.elections.study_type_id)) {
      this.setState({
        constituency_id: [],
        constituency_str: [],
        constituency_virt_str: [],
        constituency_virt_id: [],
        regional_data: []
      })
    }
    if (!_.isEqual(prevProps.elections.dashboard_elections_filters, this.props.elections.dashboard_elections_filters)) {
      this.setState({
        showTableDetails: false
      })
    }
  }

  private rowClick: any = (index: number, state: any, rowInfo: any | undefined, column: any) => {
    const { elections } = this.props;
    let filters: IElectionFilters = elections.dashboard_elections_filters as any
    let filters_details: IElectionDetailFilters = {
      media_ids: filters.media_ids,
      study_type_id: filters.study_type_id,
      date_end: filters.date_end,
      date_start: filters.date_start,
      time_slot_start: filters.time_slot_start,
      time_slot_end: filters.time_slot_end,
      program_editor_ids: filters.program_editor_ids,
      program_type_ids: filters.program_type_ids
    }
    if (rowInfo && column.Header !== '') {
      filters_details = {
        ...filters_details,
        political_group_id: rowInfo.original.political_group_id,
        detail_etude_id: rowInfo.original.detail_etude_id
      }
      if (column.parent !== undefined && column.parent.cid !== undefined && typeof (column.parent.cid) === 'number') {
        filters_details = {
          ...filters_details,
          program_type_ids: [column.parent.cid]
        }
      }
      if (column.parent !== undefined && column.parent.id !== undefined && !filters_details.detail_etude_id) {
        filters_details = {
          ...filters_details,
          detail_etude_id: parseInt(column.parent.id)
        }
      }
      if (column.Header === 'Soutiens') {
        filters_details = {
          ...filters_details,
          person_function: PersonFunction.SOUTIEN
        }
      } else if (column.Header === 'Candidats') {
        filters_details = {
          ...filters_details,
          person_function: PersonFunction.CANDIDAT
        }
      }
      let disableClick: boolean = false;
      if (rowInfo.original[column.id] === '--') {
        disableClick = true
      }
      if (!disableClick) {
        this.props.getDashboardElectionDetail(filters_details)
        this.setState({
          showTableDetails: true,
          selectedCell: rowInfo.original,
          selectedIndex: index
        })
      }
    }
  }
  private buildNatTable() {
    return (
      <div>
        {
          this.props.elections.timeAllocationsLoading ?
            <div style={{ paddingTop: 30 }}>
              {`${this.props.i18n._('Loading')} ...`}
            </div> :
            this.props.elections.timeAllocationResults === null ?
              <div style={{ paddingTop: 30 }}>
                {this.props.i18n._('Please select filters')}
              </div>
              :
              this.props.elections.time_allocation_hms.length === 0 ?
                <div style={{ paddingTop: 30 }}>
                  {this.props.i18n._('No results')}
                </div>
                :
                <ElectionTableDashboard
                  resizeTable={false}
                  tableType={ElectionType.NATIONAL}
                  data={this.props.dashboard.filters.display_format === 'duration' ? this.props.elections.time_allocation_hms : this.props.elections.time_allocation_percent}
                  columns={this.props.elections.elections_legis_nat_columns}
                  rowClick={this.rowClick.bind(this, -1)}
                  showLogo={true}
                />
        }
      </div>
    )
  }
  private onTabChange(ev: MouseEvent, value: ElectionType) {
    this.setState({
      activeTab: value
    })
    this.props.setElectionTable(value)
  }
  private handleCirconscriptionsList(ev: any, is_nat: boolean) {
    ev.preventDefault();
    ev.stopPropagation();
    this.setState({
      circMenuAnchor: ev.target as HTMLElement,
      circMenuOpen: true,
      activeTab: ElectionType.CIRCONSCRIPTION
    });
    this.props.saveCircoFilters({
      is_nat
    })
  }
  private filterList(ids: number[], str: string[], id: number, name: string) {
    if (ids.includes(id)) {
      ids = ids.filter(e => e !== id)
      str = str.filter(e => e !== name)
    } else {
      ids.push(id)
      str.push(name)
    }
    return [ids, str]
  }
  private handleConstituencyChange(ids: number[], str: string[], bool: boolean) {
    if (this.state.activeTab === ElectionType.CIRCONSCRIPTION) {
      this.setState({
        constituency_id: ids,
        constituency_str: str,
        isAllCirconscriptionsSelected: bool,
        activeTab: ElectionType.CIRCONSCRIPTION
      })
    } else if (this.state.activeTab === ElectionType.CIRCONSCRIPTION_VIRTUELLE) {
      this.setState({
        constituency_virt_id: ids,
        constituency_virt_str: str,
        isAllCirconscriptionsVirtSelected: bool,
        activeTab: ElectionType.CIRCONSCRIPTION_VIRTUELLE
      })
    }
  }
  private updateItems(ev: any, id: number, name: string) {
    ev.preventDefault();
    ev.stopPropagation();
    let result = this.state.activeTab === ElectionType.CIRCONSCRIPTION ?
      this.filterList(this.state.constituency_id, this.state.constituency_str, id, name) :
      this.filterList(this.state.constituency_virt_id, this.state.constituency_virt_str, id, name)
    let newIDs = result[0] as number[]
    let newStr = result[1] as string[]
    let newIsAllItemsSelected = false

    this.handleConstituencyChange(newIDs, newStr, newIsAllItemsSelected)
  }
  private handleAllList(ids: number[], str: string[], isAllitemsSelected: boolean, allID: number[], allStr: string[]) {
    if (isAllitemsSelected) {
      ids = [];
      str = []
    } else {
      ids = allID
      str = allStr
    }
    return [ids, str]
  }
  private handleAllItems() {
    let result: any = this.state.constituency_str !== null && this.handleAllList(this.state.constituency_id, this.state.constituency_str,
      this.state.isAllCirconscriptionsSelected,
      this.props.elections.allCirconscriptionsId, this.props.elections.allCirconscriptionsStr)
    this.handleConstituencyChange(result[0], result[1], !this.state.isAllCirconscriptionsSelected)
  }
  private handleCircMenuClose(ev: any) {
    ev.preventDefault();
    ev.stopPropagation();
    this.setState({ circMenuAnchor: null, circMenuOpen: false });
    let filters: IElectionFilters = { ...this.props.elections.dashboard_elections_filters } as any
    this.props.saveCircoFilters({
      circo_ids: this.state.isAllCirconscriptionsSelected ? undefined : this.state.constituency_id,
      circo_virt_ids: this.state.isAllCirconscriptionsVirtSelected ? undefined : this.state.constituency_virt_id,
      is_nat: filters.study_type_id === 30 || filters.study_type_id === 32 ? true : false
    })
  }
  private handleCircSearch() {
    this.setState({ circMenuAnchor: null, circMenuOpen: false });
    if (this.props.elections.dashboard_elections_filters !== null) {
      let filters: IElectionFilters = {
        ...this.props.elections.dashboard_elections_filters,
        detail_etude_id: this.state.constituency_id
      }
      this.props.getTimeAllocationLegislative(filters)
    }
  }
  private buildMenu() {
    const { classes, i18n } = this.props;
    return (
      <>
        <MD.Tabs
          className={classes.tabs}
          onChange={this.onTabChange.bind(this) as any}
          value={this.state.activeTab}
        >
          <MD.Tab
            className={classes.hide}
            label={i18n._('National').toUpperCase()}
            value={ElectionType.NATIONAL}
          />
          <MD.Tab
            onClick={(ev: any) => this.handleCirconscriptionsList(ev, false)}
            className={classes.hide}
            label={
              <div>
                {i18n._('Circonscriptions').toUpperCase()} <ArrowDropDownIcon style={{ verticalAlign: 'middle' }} />
              </div>
            }
            value={ElectionType.CIRCONSCRIPTION}
          />
        </MD.Tabs>
        {this.props.elections.circonscriptions.length === 0 &&
          this.props.elections.get_circo_list_loading &&
          <MD.Menu
            anchorEl={this.state.circMenuAnchor}
            anchorOrigin={{
              horizontal: 'right',
              vertical: 'top',
            }}
            style={{ top: 130, left: 30 }}
            className={this.props.classes.menus}
            id='circo'
            transformOrigin={{
              horizontal: 'right',
              vertical: 'bottom',
            }}
            onClose={this.handleCircMenuClose.bind(this) as any}
            open={this.state.circMenuOpen}
          >
            <MD.Grid style={{ margin: '16px' }}>
              <MD.CircularProgress color='primary' />
            </MD.Grid>
          </MD.Menu>
        }
        {this.props.elections.circonscriptions.length > 0 &&
          <MD.Menu
            anchorEl={this.state.circMenuAnchor}
            anchorOrigin={{
              horizontal: 'right',
              vertical: 'top',
            }}
            style={{ top: 130, left: 30 }}
            className={this.props.classes.menus}
            id='circo'
            transformOrigin={{
              horizontal: 'right',
              vertical: 'bottom',
            }}
            onClose={this.handleCircMenuClose.bind(this) as any}
            open={this.state.circMenuOpen}
          >
            <MD.MenuItem
              value={'All'}
              onClick={() => this.handleAllItems()}
              key={'ALL'}
              style={{ padding: '0px', height: '25px' }}
            >
              <MD.Checkbox
                checked={this.state.isAllCirconscriptionsSelected}
                style={{ color: this.state.isAllCirconscriptionsSelected ? this.props.theme.palette.primary.main : this.props.theme.palette.primary.light }}
              />
              <MD.ListItemText style={{ paddingLeft: '0px' }} primary={i18n._('ALL')} />
            </MD.MenuItem>
            {this.props.elections.circonscriptions.map(x => {
              return (
                <MD.MenuItem
                  onClick={(ev: any) => this.updateItems(ev, x.id, x.name)}
                  key={x.id} value={x.id}
                  style={{
                    paddingLeft: '0px',
                    height: '25px',
                    backgroundColor: (this.state.constituency_id.indexOf(x.id) > -1 || this.state.isAllCirconscriptionsSelected) ? 'rgba(0, 0, 0, 0.08)' : 'inherit'
                  }}>
                  <MD.Checkbox
                    style={{
                      color:
                        (this.state.constituency_id.indexOf(x.id) > -1 || this.state.isAllCirconscriptionsSelected) ? this.props.theme.palette.primary.main : this.props.theme.palette.primary.light
                    }}
                    checked={this.state.constituency_id.indexOf(x.id) > -1 || this.state.isAllCirconscriptionsSelected}
                  />
                  <MD.ListItemText style={{ paddingLeft: '0px' }} primary={x.name} />
                </MD.MenuItem>
              )
            })}
            <MD.Button type="button" href="#" className={this.props.classes.searchButton}
              color='secondary'
              onClick={this.handleCircSearch.bind(this)}
              variant='contained'>
              {i18n._('Validate')}
            </MD.Button>
          </MD.Menu>
        }
      </>
    )
  }
  private buildExport() {
    let filters: any = this.props.elections.isElectionPresedentielle ? this.props.elections.time_allocation_filters :
      this.props.elections.dashboard_elections_filters;
    return (
      <div style={{ position: 'absolute', right: '15px', display: 'inline-flex' }}>
        {filters !== null &&
          <Export title={this.props.i18n._("Relevés horodatés").toUpperCase()}
            exportAction={() => this.props.getXlsDashboardElectionDetail(filters)}
            filters={filters} exportType='xls' />
        }
        {filters !== null &&
          <Export
            exportAction={() => this.props.getXlsDashboardLegislativ(filters)}
            filters={filters} exportType='xls' />
        }
      </div>
    )
  }
  private buildDetailsTable() {
    const { classes, i18n } = this.props;
    return (
      this.props.elections.isLoadingDetail ?
        <div style={{ paddingTop: 30 }}>
          {i18n._('Loading')}..
        </div>
        : this.props.elections.dashboardElectionDetail === null ?
          <div style={{ paddingTop: 30 }}>
            {i18n._('No results')}
          </div>
          :
          <>
            <div id='top-table-infos' className={classes.topTableInfos} style={{ paddingTop: 30 }}>
              <span id="table-name" className={classes.tableName}>
                {/*this.state.selectedCell*/}
              </span>
              <MD.IconButton
                className={classes.closeWindow}
                onClick={() => this.setState({
                  showTableDetails: false
                })}
              >
                <BiWindowClose title={i18n._('Close')} />
              </MD.IconButton>
            </div>
            {
              this.props.elections.dashboardElectionDetail !== null &&
              <ElectionTableDetails
                filters={this.props.elections.dasboardDetailsFilters}
                data={this.props.elections.dashboardElectionDetail}
                showFilters={true}
              />
            }
          </>
    )
  }
  private scrollTo(id: number) {
    var elmnt = document.getElementById(`${id}`);
    !isNullOrUndefined(elmnt) && elmnt.scrollIntoView();
  }
  private buildCirconsTable(loading: boolean, data: IDataLegisCirco | null) {
    return (
      <div>
        {
          loading ?
            <div style={{ paddingTop: 30 }}>
              {`${this.props.i18n._('Loading')} ...`}
            </div> :
            data === null ?
              <div style={{ paddingTop: 30 }}>
                {this.props.i18n._('Please select filters')}
              </div> :
              data !== null && Object.keys(data).length === 0 ?
                <div style={{ paddingTop: 30 }}>
                  {this.props.i18n._('No results')}
                </div> :
                <MD.List style={{ overflow: 'auto', height: 600 }}>
                  {
                    Object.keys(data).map((data_name: string, index: any) => {
                      let table_data: IDataHmsPercent = data[data_name];
                      let columns = this.props.elections.elections_legis_cir_columns;
                      let new_columns: any = [...columns]
                      let json: any = new_columns[0]
                      json = {
                        ...json,
                        Header: data_name
                      }
                      new_columns[0] = json
                      return (
                        <MD.ListItem
                          key={index}
                          alignItems="flex-start"
                          id={index}
                          ref={(ref: any) => {
                            if (this.itemRefs.length < data.length) {
                              this.itemRefs[table_data.id] = ref
                            }
                            if (index === this.state.selectedIndex) {
                              this.scrollTo(this.state.selectedIndex)
                            }
                            return this.itemRefs
                          }
                          }
                        >
                          <ElectionTableDashboard
                            key={index}
                            resizeTable={true}
                            data={this.props.dashboard.filters.display_format === 'duration' ?
                              table_data.data_hms : table_data.data_percent}
                            columns={new_columns}
                            rowClick={this.rowClick.bind(this, index)}
                            showLogo={false}
                          />
                        </MD.ListItem>
                      )
                    })
                  }
                </MD.List>
        }
      </div>
    )
  }
  private buildNatOrCircoTable() {
    return (
      <div>
        {
          (this.state.activeTab === ElectionType.NATIONAL)
          && this.buildNatTable()
        }
        {
          (this.state.activeTab === ElectionType.CIRCONSCRIPTION) &&
          this.buildCirconsTable(
            this.props.elections.timeAllocationsLoading,
            this.props.elections.data_legis_circo
          )
        }
      </div>
    )
  }
  public render(): React.ReactNode {
    return (
      <>
        {!this.state.showTableDetails ?
          <>
            <div style={{ paddingTop: 30, display: 'inline-flex' }}>
              {this.buildExport()}
              {((this.props.elections.dashboard_elections_filters !== null) && (this.props.elections.study_type_id !== 40)) && this.buildMenu()}
            </div>
            {this.buildNatOrCircoTable()}
          </>
          :
          this.buildDetailsTable()
        }
      </>
    )
  }

}

const mapStateToProps = ({ i18n, dashboard, search, user, elections }: IApplicationState, ownProps: RouteComponentProps<{}>) => {
  return {
    i18n: i18n.i18n,
    localeInfos: i18n.localeInfos,
    router: ownProps,
    dashboard,
    search,
    user,
    elections
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getDashboardDetail: (filters: IFiltersDetail) => dispatch(getDashboardDetail(filters)),
  setElectionTable: (tableType: ElectionType) => dispatch(setElectionTable(tableType)),
  getDashboardCirconscription: (filters: IElectionFilters) => dispatch(getDashboardCirconscription(filters)),
  getXlsDashboardElectionDetail: (filters: IElectionFilters) => dispatch(getXlsDashboardElectionDetail(filters)),
  getXlsDashboardElection: (filters: IElectionFilters) => dispatch(getXlsDashboardElection(filters)),
  getXlsDashboardLegislativ: (filters: IElectionFilters) => dispatch(getXlsDashboardLegislativ(filters)),
  saveCircoFilters: (filters: ICircoFilters) => dispatch(saveCircoFilters(filters)),
  getDashboardElectionDetail: (filters: IElectionDetailFilters) => dispatch(getDashboardElectionDetail(filters)),
  getTimeAllocationLegislative: (filters: IElectionFilters) => dispatch(getTimeAllocationLegislative(filters)),
});


export const ElectionsLegisContent =
  connect(mapStateToProps, mapDispatchToProps)
    (MD.withTheme(MD.withStyles(styles)(ElectionsLegisContentComponent)));
